import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

/**
 * An image shown full size over the current screen, without leaving it.
 *
 * Closed by the ✕, a tap on the dark backdrop, or Esc. Rendered into <body> so a parent's
 * overflow or z-index cannot clip it. Renders nothing while `src` is empty, so callers can keep
 * it mounted and just set or clear the image.
 */
export default function ShowImageFull({ src, onClose }) {
    useEffect(() => {
        if (!src) return undefined;
        const onKey = (e) => { if (e.key === "Escape") onClose(); };
        window.addEventListener("keydown", onKey);
        //* The page behind must not scroll while the image is open.
        const overflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = overflow;
        };
    }, [src, onClose]);

    if (!src) return null;

    return ReactDOM.createPortal(
        <div
            onClick={onClose}
            style={{
                position: "fixed", top: 0, right: 0, bottom: 0, left: 0, zIndex: 3000,
                background: "rgba(0, 0, 0, 0.85)",
                display: "flex", alignItems: "center", justifyContent: "center",
                padding: 16, cursor: "zoom-out",
            }}
        >
            <img
                src={src}
                alt=""
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: "95vw", maxHeight: "90vh", objectFit: "contain", borderRadius: 6, cursor: "default" }}
            />
            <div
                onClick={onClose}
                title="ປິດ"
                style={{
                    position: "fixed", top: 16, right: 20, width: 40, height: 40, borderRadius: "50%",
                    background: "rgba(255, 255, 255, 0.15)", color: "#FFF", fontSize: 22,
                    display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                }}
            >
                <FontAwesomeIcon icon={faXmark} />
            </div>
        </div>,
        document.body
    );
}
